<template>
  <div class="Product">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="queryData">
          <el-input
            style="width: 150px"
            placeholder="请输入名称"
            v-model.trim="queryData.eq[0][2]"
            @keyup.enter.native="getDataList(true)"
            clearable
          >
          </el-input>
          <el-button type="success" @click="getDataList">查询</el-button>
          <el-button class="inputR" type="primary" @click="addOrEditPopup(0)"
            >新增</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loadingFlag"
        element-loading-text="正在拼命加载中"
        element-loading-spinner="el-icon-loading"
        :tree-props="{ children: 'list' }"
        row-key="Id"
        stripe
      >
        <el-table-column type="index" label="#" width="200"></el-table-column>
        <el-table-column prop="name" label="名称" min-width="500">
        </el-table-column>
        <!-- <el-table-column prop="createTime" label="创建时间" min-width="180">
          <template slot-scope="scope">
            <div>{{ VueDateFormat(scope.row.createTime) }}</div>
          </template>
        </el-table-column> -->
        <el-table-column fixed="right" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="addOrEditPopup(scope.row)"
              style="marin-right: 20px"
              >编辑</el-button
            >
            <span class="operationLine">|</span>
            <el-button type="text" @click="baseDeleteById(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="getDataListSizeChange"
        @current-change="getDataListCurrentChange"
        :current-page="queryData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="dataForm.id ? '修改' : '新增'"
      :visible.sync="centerDialogVisible"
      width="600px"
      center
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="60px"
        :rules="dataFormRules"
      >
        <el-form-item prop="name" label="名称">
          <el-input
            v-model.trim="dataForm.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDataForm" :loading="loadingFlag"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      queryData: {
        current: 1,
        size: 10,
        eq: [["String", "name", ""]],
      },
      total: 0,
      centerDialogVisible: false,
      dataForm: {},
      dataFormRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      loadingFlag: false,
    };
  },
  created() {},
  mounted() {
    this.getDataList();
  },
  methods: {
    // 新增
    addOrEditPopup(row) {
      this.centerDialogVisible = true;
      if (row) {
        this.dataForm = JSON.parse(JSON.stringify(row));
      } else {
        this.dataForm = {
          sort: 1,
          status: 1,
        };
      }
    },

    /**
     * 删除数据
     */
    baseDeleteById(id) {
      if (id) {
        this.$confirm("是否删除所选择的数据?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http.delete(`/sys-city/baseDeleteById/${id}`).then((res) => {
              if (res.data.code == 200) {
                this.getDataList();
                this.$VueMessage({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$VueMessage({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          })
          .catch(() => {
            this.$VueMessage({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 查询
    getDataList(flag) {
      let data = this.queryData;
      if (flag) data.current = 1;
      this.loadingFlag = true;
      this.$http
        .post(`/sys-city/page`, this.$guolv(this.queryData))
        // .get(`/job-type/getSelectPage`, {
        //   params: data,
        // })
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let list = data.records;
              this.tableData = list;
              this.total = data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataListSizeChange(val) {
      this.queryData.size = val;
      this.getDataList(true);
    },
    getDataListCurrentChange(val) {
      this.queryData.current = val;
      this.getDataList();
    },

    /**
      提交
     */
    // uploadSuccess(res) {
    //   this.$store.state.beforeUploadLoading.close();
    //   this.$set(this.dataForm, "backgroundImage", res.data);
    // },
    submitDataForm() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.loadingFlag = true;
          let url = "/sys-city/saveOrUpdate";
          let data = this.dataForm;
          this.$http.post(`${url}`, data).then((res) => {
            this.loadingFlag = false;
            if (res.data.code == 200) {
              this.$VueMessage({
                message: "操作成功",
                type: "success",
              });
              this.centerDialogVisible = false;
              this.getDataList();
              // this.$emit("refreshDataList");
            } else {
              this.$VueMessage({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
  },
};
</script>
